/** Run-only override: keep the physical row model but omit saved scene shading. */
export function configWithoutLayoutShading(config) {
  const withoutEvidence = (record) => {
    if (!record || typeof record !== "object") return record;
    const { obstacleShading, ...rest } = record;
    return rest;
  };
  return {
    ...config,
    runWithoutLayoutShading: true,
    pv_design: withoutEvidence(config?.pv_design),
    ...(Array.isArray(config?.orientations)
      ? { orientations: config.orientations.map(withoutEvidence) }
      : {}),
  };
}
